import API from "../api"

const ProductTypeService = {
  getProductTypesHierarchy: () => API.get(`org/product-type`),
};

export default ProductTypeService;
